import React from "react";
import PropTypes from "prop-types";
import ButtonCard from "../cards/button-card/button-card";

const WDMPTDGButtonCard = ({  cardColor, cardData }) => {
    return (
        <ButtonCard
            cardColor={cardColor}
            cardData={cardData}
            customButtonComponent={null}
        />
    );
};

WDMPTDGButtonCard.propTypes = {
    cardColor: PropTypes.string,
    cardData: PropTypes.object
};

export default WDMPTDGButtonCard;
